/**
 * Metnin **UTF-8 bayt** uzunluğu.
 *
 * <p><b>Neden gerekli (kullanıcı bulgusu 2026-09-15):</b> Oracle şemasındaki metin kolonlarının tamamı
 * **BYTE** semantiğindedir (`ALL_TAB_COLUMNS.CHAR_USED = 'B'`, `AL32UTF8`) — yani `VARCHAR2(2000)` 2000
 * **bayt** tutar, 2000 karakter değil. Türkçe'ye özgü harfler (`ç ğ ı ö ş ü İ Ğ Ş Ö Ü Ç`) UTF-8'de 2
 * bayttır. `maxLength` ve zod'un `.max()`'ı ise **karakter** sayar; ikisi de sınıra kadar dolu bir Türkçe
 * metni geçirir ve kayıt sunucuda düşerdi.
 *
 * <p>`TextEncoder` her modern tarayıcıda ve jsdom'da vardır; `String.length` UTF-16 kod birimi saydığı
 * için (Türkçe harflerde 1, emojide 2) bayt uzunluğunun yerine **geçmez**.
 */
export function utf8Length(value: string): number {
  return new TextEncoder().encode(value).length
}
